import { defaults } from 'typed/api';
import { Action } from 'typed/actions';
import { combineReducers, entityAddReducer, entityDeleteReducer, entityEditReducer, entityLoadAllReducer, switchReducers } from './utils';

const
    market = defaults.Market,
    marketNetworkArray = defaults.NetworkArrayOf(market),
    marketFreeNode = defaults.MarketFreeNode,
    marketFreeNodeNetworkArray = defaults.NetworkArrayOf(marketFreeNode);

export default combineReducers({
    markets: switchReducers(marketNetworkArray,
        entityLoadAllReducer(marketNetworkArray, 'LOAD_ALL_MARKETS'),
        entityAddReducer(marketNetworkArray, 'ADD_MARKET'),
        entityEditReducer(marketNetworkArray, 'EDIT_MARKET'),
        entityDeleteReducer(marketNetworkArray, 'DELETE_MARKET')
    ),
    marketFreeNodes: switchReducers(marketFreeNodeNetworkArray,
        entityLoadAllReducer(marketFreeNodeNetworkArray, 'LOAD_ALL_MARKET_FREE_NODES'),
        entityAddReducer(marketFreeNodeNetworkArray, 'ADD_MARKET_FREE_NODE'),
        entityEditReducer(marketFreeNodeNetworkArray, 'EDIT_MARKET_FREE_NODE'),
        entityDeleteReducer(marketFreeNodeNetworkArray, 'DELETE_MARKET_FREE_NODE')
    ),
    marketMapExpandedNodes: (
        state: {
            defaultNodeIDs: number[],
            marketIDs: number[],
            marketCategoryIDs: number[],
            marketTrendTypeIDs: number[],
            trendCategoryIDs: number[],
            marketFreeNodeIDs: number[]
        } = {
                defaultNodeIDs: [],
                marketIDs: [],
                marketCategoryIDs: [],
                marketTrendTypeIDs: [],
                trendCategoryIDs: [],
                marketFreeNodeIDs: []
            },
        action: Action<'SET_MARKET_MAP_EXPANDED_NODES'>
    ) => {
        if (action.type === 'SET_MARKET_MAP_EXPANDED_NODES') {
            return {...action.payload.expandedNodes };
        }
        return state;
    },
});